<button
  [ngClass]="config().styleClass"
  [ngStyle]="config().style"
  [disabled]="config().isDisabled"
  (click)="onClick()"
  mat-flat-button
>
  {{ label() }}
</button>
